export const educationData = [
    {
        id: 4,
        institution: 'React Native',
        course: ' META',
        // startYear: '2023',
        endYear: '2024'
    },
    {
        id: 3,
        institution: 'React JS',
        course: ' META',
        // startYear: '2023',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Project Management',
        course: 'Google ',
        // startYear: '2023',
        endYear: '2023'
    },
    {
        id: 1,
        institution: 'University of Agriculture Faisalabad',
        course: 'BS Information Technology',
        startYear: '2018 - ',
        endYear: '2022'
    },
]